<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <residents-filter v-model="filter" @input="paginate" />
    <new-resident @created="handlePaginate" :finance_client="finance_client" />
    <new-resident-from-client @created="paginate" />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <b-row>
          <b-col cols="auto">
            <v-btn class="btn-return" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> VOLTAR
            </v-btn>
          </b-col>
          <b-col>
            <h1 class="title-pages pt-1 check-text-center">RESIDENTES</h1>
          </b-col>
          <b-col cols="auto">
            <v-btn
              @click="$bvModal.show('residents_filter')"
              class="btn-filter ml-2"
              type="relief"
            >
              <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
            </v-btn>
            <v-btn
              v-if="permission('write', 'resident')"
              class="btn-add ml-2"
              @click="$bvModal.show('new_resident')"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
            <v-btn
              v-if="false"
              class="btn-add ml-2"
              @click="$bvModal.show('new_resident_from_client')"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i>
              ADICIONAR A PARTIR DE CLIENTE
            </v-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="PESQUISAR RESIDENTES"
              outlined
              dense
              hide-details
            />
          </b-col>
        </b-row>
        <WarningMessage
          class="mt-5 text-center"
          v-if="!permission('read', 'resident')"
          message="Você não tem permissão para visualizar residentes"
        />
        <div v-if="permission('read', 'resident')">
          <div class="v-clean p-5 text-center" v-show="residents.length == 0">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="residents.length > 0"
            dense
            :headers="headers"
            :items="residents"
            :search="search"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.date_of_birth`]="{ item }">
              <td>
                <span
                  v-b-tooltip.html
                  :title="`Data de nascimento <br /> ${formatDate(
                    item.date_of_birth,
                    false
                  )}`"
                  >{{ getAge(item.date_of_birth) }} anos</span
                >
              </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn small class="btn-edit m-1" @click="viewResident(item)">
                <i class="fas fa-pencil-alt mr-2 text-twenty" /> EDITAR
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import api from "../services/api";
import permission from "../lib/permission";
import WarningMessage from "../templates/Components/WarningMessage";
import { formatDate } from "../lib/format";
import { getAge } from "../lib/getAgeByDate";
import NewResident from "../templates/residents/new-resident.vue";
import ResidentsFilter from "../templates/residents/residents-filter.vue";
import NewResidentFromClient from "../templates/residents/new-resident-from-client.vue";

export default {
  name: "Residents",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    NewResident,
    ResidentsFilter,
    NewResidentFromClient,
  },

  data() {
    return {
      errors: [],
      finance_client: [],
      loading: false,
      filter: {},

      search: "",
      headers: [
        { text: "Status", value: "status_type_name" },
        { text: "Nome", value: "name" },
        { text: "Idade", value: "date_of_birth" },
        { text: "Sexo", value: "gender_name" },
        { text: "Ações", value: "actions" },
      ],
      residents: [],
    };
  },
  created() {
    this.financeClient();
  },
  methods: {
    permission,
    getAge,
    formatDate,

    viewResident(item) {
      this.$router.push({
        name: "resident",
        params: { id: item.id },
        query: {
          tab: "informations",
          action: "geral",
        },
      });
    },

    handlePaginate() {
      this.financeClient();
      this.paginate();
    },

    async financeClient() {
      try {
        const response = await api.get(
          "/rest-home/financial/non-resident-clients"
        );

        const { clients } = response.data;

        this.finance_client = clients;
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        this.loading = true;

        const params = { status: this.filter.status };
        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });
        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
